<template>
  <!-- ONE ROOT -->
  <transition name="vpd-modal-fade">
    <div v-if="dialog" class="vpd-modal-wrap">
      <transition name="vpd-backdrop-fade">
        <div class="vpd-modal_backdrop" @click.self="closeModal" />
      </transition>

      <transition name="vpd-modal-slide">
        <div :class="{ 'vpd-modal--fullscreen': isFullScreen }" class="vpd-modal" role="dialog" aria-modal="true"
          :aria-labelledby="titleId" ref="panel">
          <!-- HEADER -->
          <header :class="{ 'vpd-modal_header--fullscreen': isFullScreen }" class="vpd-modal_header">
            <h2 :class="{ 'vpd-modal_title--fullscreen': isFullScreen }" class="vpd-modal_title" :id="titleId">{{ title
            }}</h2>
            <img class="vpd-modal_close" :src="closeIcon" alt="Bezár" height="24px" @click="closeModal" />
          </header>

          <section class="vpd-modal_body">
            <slot />
          </section>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import closeIcon from "@/assets/x.svg";

export default {
  name: 'VpdCustomDialog',
  props: {
    dialog: { type: Boolean, required: true },
    title: { type: String, required: true },
    isFullScreen: { type: Boolean, required: false }
  },
  data() {
    return {
      closeIcon,
      titleId: `vpd-title-${this._uid}`
    }
  },
  watch: {
    dialog(show) {
      document.documentElement.style.overflow = show ? 'hidden' : ''
      if (show) this.$nextTick(() => this.$refs.panel && this.$refs.panel.focus())
    }
  },
  methods: { closeModal() { this.$emit('close-modal') } }
}
</script>

<style scoped>
.vpd-modal-wrap {
  position: fixed;
  inset: 0;
  z-index: 2;
  top: 80px;
}

.vpd-modal_backdrop {
  position: absolute;
  inset: 0;
  background: #45658F80;
}

.vpd-modal {
  display: flex;
  flex-direction: column;
  position: relative;
  place-items: center;
  background: white;
  width: 50%;
  height: 100%;
  float: right;
}

.vpd-modal--fullscreen {
  width: 100% !important;
  height: 100%;
  border-radius: 0;
}

.vpd-modal_header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
}

.vpd-modal_header--fullscreen {
  margin-top: 40px;
}

.vpd-modal_title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  color: black;
}

.vpd-modal_title--fullscreen {
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  width: 100%;
  max-width: 676px;
  padding-left: 14px;
  text-align: start;
}

.vpd-modal_close {
  cursor: pointer;
  margin-right: 16px;
}

.vpd-modal_body {
  padding: 20px;
  height: 100%;
  width: 100%;
  justify-content: center;
  display: flex;
  overflow: auto;
  background: #fff;
}

/* Animation styles */
.vpd-modal-fade-enter-active,
.vpd-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.vpd-modal-fade-enter,
.vpd-modal-fade-leave-to {
  opacity: 0;
}

.vpd-backdrop-fade-enter-active,
.vpd-backdrop-fade-leave-active {
  transition: opacity 0.2s ease;
}

.vpd-backdrop-fade-enter,
.vpd-backdrop-fade-leave-to {
  opacity: 0;
}

.vpd-modal-slide-enter-active,
.vpd-modal-slide-leave-active {
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.vpd-modal-slide-enter,
.vpd-modal-slide-leave-to {
  transform: translateX(100%);
}

@media (max-width: 1200px) {
  .vpd-modal {
    width: 60%;
  }
}

@media (max-width: 992px) {
  .vpd-modal {
    width: 70%;
  }
}

@media (max-width: 768px) {
  .vpd-modal {
    width: 95%;
  }
}

@media (max-width: 576px) {
  .vpd-modal-wrap {
    top: 68px;
  }

  .vpd-modal_backdrop {
    inset: unset;
    top: -67px;
    width: 100%;
    height: 100%;
  }

  .vpd-modal {
    width: 100%;
    border-radius: 16px;
  }

  /* Slide up animation for mobile */
  .vpd-modal-slide-enter,
  .vpd-modal-slide-leave-to {
    transform: translateY(100%);
  }

  .vpd-modal_title--fullscreen {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    text-align: center;
  }

  .vpd-modal_header--fullscreen {
    margin-top: 0px;
  }
}
</style>